import fetch from "unfetch";
let back_url = "http://localhost/pob/";
if (process.env.REACT_APP_ENV === "production")
  back_url = "https://princessobomefoundation.org/";
const url = back_url + "wp-json/formfiller/v1/";

const checkStatus = (response) => {
  if (response.ok) {
    return response;
  }
  if (response.ok === false && response.status === 401) {
    doSignOut();
  }
  const error = new Error(response.statusText);
  error.response = response;
  return Promise.reject(error);
};

const submitRequest = async (endpoint, method, values) => {
  const response = await fetch(url + endpoint + "/", {
    method: method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(values),
  });
  return checkStatus(response);
};
export const isLoggedIn = () => {
  return parseInt(getStoredItem("uid")) > 0;
};
export const submitFormPart = (values) => {
  return submitRequest("form", "PUT", values);
};

export const deleteUserFile = (values) => {
  return submitRequest("doc", "DELETE", values);
};

export const doLogin = (values) => {
  return submitRequest("user", "POST", values);
};

export const doCreateAccount = (values) => {
  return submitRequest("user", "PUT", values);
};
export const doVerifyAccount = (values) => {
  return submitRequest("user/verify", "POST", values);
};
export const doAccountReset = (values) => {
  return submitRequest("user/reset", "POST", values);
};
export const doConfirmAccountReset = (values) => {
  return submitRequest("user/reset/confirm", "POST", values);
};

export const doConfirmAccountResetFinal = (values) => {
  return submitRequest("user/reset/final", "POST", values);
};

export const getClientPaymentSecret = () => {
  return submitRequest("payment", "GET", []);
};

export const doSignOut = () => {
  const itemsToRemove = [
    "uid",
    "token",
    "form",
    "progress",
    "formData",
    "previousFormId",
    "canGoBack",
    "menu",
    "openMenu",
    "currentFormId",
    "welcomeMessage",
    "applicationHeader",
  ];
  itemsToRemove.forEach((i) => {
    localStorage.removeItem(i);
  });
  window.location.reload();
};
export const images_folder = (part) => {
  return back_url + "wp-content/plugins/form-filler/public/images/" + part;
};
export const site_url = (path) => {
  return back_url + "wp-json/formfiller/v1/" + path;
};
export const get_uploaded_image_url = (filename, element_id) => {
  return site_url(
    "doc/?uid=" +
      getStoredItem("uid") +
      "&token=" +
      getStoredItem("token") +
      "&eid=" +
      element_id +
      "&file=" +
      filename
  );
};
export const getURL = (url) => {
  return process.env.PUBLIC_URL + url;
};

export const getStoredItem = (name) => {
  return JSON.parse(localStorage.getItem(name));
};
